import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('money-burst-filters', '.hero-filters, .mb-search', (filters) => {
    const multiselects = [...filters.querySelectorAll('.hero-filters__multiselect')]
    const categoriesWrapper = document.querySelector('.hero-filters__multiselect#categories .hero-filters__multiselect-list')
    const searchInput = filters.querySelector('.hero-filters__search')
    const search = filters.querySelector('.hero-filters__submit')
    const isSearchPage = !!document.querySelector('.mb-search')

    let hasChecked = false;

    const toggleMultiselect = (multiselect, shouldOpen) => {
        const isOpen = multiselect.classList.contains('is-open')

        if (shouldOpen === undefined)
            shouldOpen = !isOpen

        if (!isOpen && shouldOpen) {
            multiselect.classList.add('is-open')
        } else if (isOpen && !shouldOpen) {
            multiselect.classList.remove('is-open')
            if (isSearchPage && window.triggerSearch && hasChecked) {
                hasChecked = false
                window.triggerSearch()
            }
        }
    }

    const updateLabel = (multiselect, checkbox) => {
        const label = multiselect.querySelector('.hero-filters__multiselect-label')
        const labelText = label.querySelector('[data-selectedlabel]').dataset.selectedlabel
        const count = label.querySelector('.label-count')
        const items = [...multiselect.querySelectorAll('input[type="checkbox"]')]

        hasChecked = true;

        if (checkbox && checkbox.value === 'all-categories' && checkbox.checked) {
            items.forEach((item) => {
                if (item.value !== 'all-categories') item.checked = false
            })
        }

        const allCategories = items[0].value === 'all-categories' ? items[0] : null
        const selectedItems = items.filter((item) => item.checked && item.value !== 'all-categories')

        if (selectedItems.length) {
            count.textContent = `(${selectedItems.length} ${labelText})`
            if (allCategories)
                allCategories.checked = false
        } else {
            count.textContent = ''
            if (allCategories)
                allCategories.checked = true
        }
    }

    const bindMultiselectEvents = (multiselect) => {
        const items = [...multiselect.querySelectorAll('input[type="checkbox"]')]

        // Event handler for keyboard interactions on checkboxes
        items.forEach((checkbox) => {
            bindCheckbox(checkbox);
        })

        // Keydown event for multiselect buttons
        multiselect.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                const isOpen = multiselect.classList.contains('is-open')
                toggleMultiselect(multiselect, !isOpen)
            }
        })

        // Close multiselect if clicked outside
        window.addEventListener('click', (e) => {
            if (!multiselect.contains(e.target)) {
                toggleMultiselect(multiselect, false)
            }
        })

        multiselect
            .querySelector('.hero-filters__multiselect-label')
            .addEventListener('click', () => toggleMultiselect(multiselect))
    }

    const bindCheckbox = (checkbox, multiselect) => {
        if (!multiselect)
            multiselect = checkbox.closest('.hero-filters__multiselect')
        addEvents(checkbox, 'change', () => updateLabel(multiselect, checkbox))

        checkbox.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                e.stopPropagation() // Prevent event from propagating to multiselect button
                checkbox.checked = !checkbox.checked
                updateLabel(multiselect)
            }
        })
    }

    const applySelections = (e) => {
        e.preventDefault()
        const sep = (url) => (url.includes('?') ? '&' : '?')
        const getSelections = (select) =>
            [...select.querySelectorAll('input[type="checkbox"]:checked')].map((item) => item.value).join(',')
        const href = multiselects.reduce((accHref, select) => {
            const selections = getSelections(select)
            if (selections) accHref += `${sep(accHref)}${select.id}=${selections}`
            return accHref
        }, search.href.split('?')[0])

        if (searchInput.value)
            search.href = `${href}${sep(href)}query=${searchInput.value}`;
        else
            search.href = href;

        window.location.href = search.href
    }

    multiselects.forEach(bindMultiselectEvents)

    initObserver();

    if (search && !isSearchPage) {
        addEvents(search, 'click,', applySelections)
        addEvents(searchInput, 'enter', applySelections)
    }
    else if (search && isSearchPage)
        addEvents(search, 'click.prevent')

    function initObserver() {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) {
                            const checkbox = node?.querySelector('input[type="checkbox"]');
                            if (checkbox)
                                bindCheckbox(node)
                        }
                    })
                }
            })
        })

        if (categoriesWrapper) {
            observer.observe(categoriesWrapper, {
                childList: true, subtree: false
            })
        }
    }
})